var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    userInputColor: colors.contrasts.grey100100,
    userInputPadding: spacing.xxSmall,
    choiceInputWrapperGridColumnGap: spacing.small
  };
};
export default generateComponentTheme;